"use client";

import React from "react";
import { LogOut, ShieldAlert, Sparkles } from "lucide-react";
import { useAuthStore, roleLabel } from "@/lib/auth-store";
import { Button } from "@/components/ui/button";

export function SimulationBanner() {
  const { user, isSimulated, exitSimulation, status } = useAuthStore();

  if (!isSimulated || !user) {
    return null;
  }

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between border-b border-amber-500/30 bg-gradient-to-r from-amber-950 via-amber-900 to-amber-950 px-4 py-2 text-xs text-amber-200 shadow-md backdrop-blur-md">
      <div className="flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75"></span>
          <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500"></span>
        </span>
        <ShieldAlert className="h-4 w-4 text-amber-400" />
        <span className="font-semibold text-amber-100 uppercase tracking-wider">
          Super Admin Simulation Mode
        </span>
        <span className="hidden sm:inline text-amber-300/80">|</span>
        <span className="text-amber-200">
          Viewing as <strong className="text-white font-medium">{user.name}</strong> (
          <span className="text-amber-300">{roleLabel(user.role)}</span> &bull; {user.email})
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={() => exitSimulation()}
          className="h-7 border-amber-500/50 bg-amber-500/20 text-amber-100 hover:bg-amber-500/30 hover:text-white text-xs font-medium"
        >
          <LogOut className="mr-1.5 h-3.5 w-3.5" />
          Exit Simulation
        </Button>
      </div>
    </div>
  );
}
